import { Component, OnInit, Input } from '@angular/core';
import { IconButtonTypeEnum } from '../shared/models/enums/icon-button-type-enum';

@Component({
    selector: 'app-advanced-button',
    templateUrl: './advanced-button.component.html',
    styleUrls: ['./advanced-button.component.scss'],
    standalone: false
})
export class AdvancedButtonComponent implements OnInit {

  public iconButtonType!: any;
  
  @Input() text!: string;
  @Input() iconType!: number;
  @Input() type!: number;
  @Input() isIconEnabled = true
  
  constructor() { this.iconButtonType = IconButtonTypeEnum}

  ngOnInit(): void {
  }

}
